import React from 'react';
import StarRating from 'components/review/StarRating';
import 'assets/scss/pages/Review.scss';

const ReviewSummary = ({ summary }) => {
    if (!summary) return null;

    const { average_rating = 0, total_count = 0, rating_distribution = {} } = summary;
    const maxCount = Math.max(...Object.values(rating_distribution), 1);

    return (
        <div className="review-summary">
            <div className="review-summary__score">
                <span className="review-summary__average">{Number(average_rating).toFixed(1)}</span>
                <StarRating rating={average_rating} size={20} />
                <span className="review-summary__total">리뷰 {total_count.toLocaleString()}개</span>
            </div>

            <div className="review-summary__distribution">
                {[5, 4, 3, 2, 1].map((star) => {
                    const count = rating_distribution[star] || 0;
                    const percentage = total_count > 0 ? (count / maxCount) * 100 : 0;
                    return (
                        <div key={star} className="review-summary__bar-row">
                            <span className="review-summary__bar-label">{star}</span>
                            <div className="review-summary__bar-track" aria-label={`${star}점 ${count}개`}>
                                <div
                                    className="review-summary__bar-fill"
                                    style={{ width: `${percentage}%` }}
                                />
                            </div>
                            <span className="review-summary__bar-count">{count}</span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default ReviewSummary;
